function About() {
  return (
    <section className="page-content">
      <h2>About Us</h2>
      <p>Welcome to The Rally Zone Sports Management. We help tennis players and organizers connect through tournaments, rankings, and event support.</p>
      <p>Our mission is to grow community tennis by providing easy access to tournament information, player performance tracking, and club management tools.</p>
    </section>
  );
}

export default About;
